module.exports = __webpack_public_path__ + "img/homegoods.667ba1fb.svg";